module.exports = __webpack_public_path__ + "img/[疑问].b6984ddf.svg";